import React, { useState } from "react";
import {
  UserIcon,
  BriefcaseIcon,
  AcademicCapIcon,
  CheckCircleIcon,
  TrophyIcon,
  LanguageIcon,
  Bars3Icon,
  XMarkIcon,
} from "@heroicons/react/24/solid";

const Sidebar = ({ section, setSection }) => {
  const [isOpen, setIsOpen] = useState(false); // Mobile sidebar state

  const menuItems = [
    {
      key: "personal",
      label: "Personal Info",
      icon: <UserIcon className="w-5 h-5" />,
    },
    {
      key: "experience",
      label: "Work Experience",
      icon: <BriefcaseIcon className="w-5 h-5" />,
    },
    {
      key: "education",
      label: "Education",
      icon: <AcademicCapIcon className="w-5 h-5" />,
    },
    {
      key: "skills",
      label: "Technical Skills",
      icon: <CheckCircleIcon className="w-5 h-5" />,
    },
    {
      key: "certificates",
      label: "Certificates & Training",
      icon: <TrophyIcon className="w-5 h-5" />,
    },
    {
      key: "languages",
      label: "Languages",
      icon: <LanguageIcon className="w-5 h-5" />,
    },
  ];

  return (
    <>
      {/* Mobile Menu Button */}
      <button
        className="fixed top-9 left-4 z-50 p-2 bg-gray-800 text-white rounded-md md:hidden"
        onClick={() => setIsOpen(true)}
      >
        <Bars3Icon className="w-6 h-6" />
      </button>

      {/* Sidebar (Fixed for Desktop, Overlay for Mobile) */}
      <div
        className={`bg-gray-800 text-white p-5 h-screen fixed top-0 transition-all duration-300 
                    md:w-64 md:block z-50 ${
                      isOpen ? "left-0 w-64" : "-left-64"
                    } md:left-0`}
      >
        {/* Close Button for Mobile */}
        <button
          className="absolute top-4 right-4 p-2 text-white md:hidden"
          onClick={() => setIsOpen(false)}
        >
          <XMarkIcon className="w-6 h-6" />
        </button>

        {/* Sidebar Content */}
        <h2 className="text-xl font-bold mb-5">Resume Sections</h2>
        <ul className="space-y-4">
          {menuItems.map(({ key, label, icon }) => (
            <li
              key={key}
              className={`flex items-center p-3 rounded-lg cursor-pointer transition ${
                section === key
                  ? "bg-blue-500"
                  : "bg-gray-700 hover:bg-gray-600"
              }`}
              onClick={() => {
                setSection(key); // Change section
                setIsOpen(false); // Close sidebar on mobile
              }}
            >
              {icon} <span className="ml-2">{label}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Mobile Overlay Background (Closes on Click) */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={() => setIsOpen(false)}
        ></div>
      )}
    </>
  );
};

export default Sidebar;
